import { useCallback, useState, useEffect } from 'react'

import addHandler from './handlers/handleAddStep'
import changeOrderHandler from './handlers/handleChangeOrder'
import deleteStepHandler from './handlers/handleDeleteStep'

export default ({ onChange, model, servings, field, appliance, stepsSelector, defaultLocale }) => {

  const handleTranslationChange = useCallback((field, translates) => {
    onChange({
      target: {
        value: translates,
        name: field,
      },
    })
  }, [onChange])

  const { selectedStep, selectStep, selectMapInfo, setSelectMapInfo } = stepsSelector

  const [showTranslatesModal, setShowTranslatesModal] = useState(null)

  useEffect(() => {
    if (!selectMapInfo.lastAppliance) {
      selectMapInfo.lastAppliance = appliance
      setSelectMapInfo(selectMapInfo)
    } else if (selectMapInfo.lastAppliance.id !== appliance.id) {
      selectMapInfo.map[selectMapInfo.lastAppliance.id] = selectedStep
      selectMapInfo.lastAppliance = appliance
      setSelectMapInfo(selectMapInfo)
      selectStep(selectMapInfo.map[appliance.id] || null)
    }
  }, [appliance, selectMapInfo, selectStep, selectedStep, setSelectMapInfo])

  const handleAddStep = addHandler({ onChange, model, field, defaultLocale, selectStep, appliance })

  const handleChangeOrder = changeOrderHandler({ onChange, field, selectStep })

  const handleDeleteStep = deleteStepHandler({ onChange, model, field, appliance, selectStep })

  const fixSelectionAfterApplianceChange = useCallback(({
    newAppliance, oldAppliance, lastSlectedStep,
  }) => {
    if (lastSlectedStep) {
      const prefix = lastSlectedStep.includes('cookingSteps') ? 'cookingSteps' : 'preparationSteps'
      const newSelection = lastSlectedStep.replace(
        `applianceSteps.${oldAppliance}.${prefix}`,
        `applianceSteps.${newAppliance}.${prefix}`,
      )
      selectMapInfo.map[newAppliance] = newSelection
      setSelectMapInfo(selectMapInfo)
    }
  }, [selectMapInfo, setSelectMapInfo])

  return {
    handleTranslationChange,
    handleAddStep,
    showTranslatesModal,
    setShowTranslatesModal,
    handleSelectStep: selectStep,
    selectedStep,
    handleDeleteStep,
    handleChangeOrder,
    fixSelectionAfterApplianceChange,
  }
}
